import { ITextBodyStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';

function merge(raw: ITextBodyStyle | null, style: ITextBodyStyle | null): ITextBodyStyle | null {
    if (!raw || !style) return raw;

    let wrapperStyle = getWrapperStyle(raw, style);
    let bodyStyle = getBodyStyle(raw, style);

    if (wrapperStyle) {
        wrapperStyle = {
            ...raw?.wrapperStyle,
            ...style?.wrapperStyle,
        };
    }

    if (bodyStyle) {
        bodyStyle = {
            ...raw?.bodyStyle,
            ...style?.bodyStyle,
        };
    }

    const autoFitType = style.autoFitType || raw.autoFitType;

    return getNewStyle(wrapperStyle, bodyStyle, autoFitType);
}

function getNewStyle(
    wrapperStyle: Record<string, any> | null,
    bodyStyle: Record<string, any> | null,
    autoFitType: string | undefined,
): ITextBodyStyle | null {
    const newStyle: ITextBodyStyle | null = (wrapperStyle || bodyStyle) ? {} : null;

    if (newStyle) {
        if (wrapperStyle) newStyle.wrapperStyle = wrapperStyle;
        if (bodyStyle) newStyle.bodyStyle = bodyStyle;
        if (autoFitType) newStyle.autoFitType = autoFitType;
    }

    return newStyle;
}

function getWrapperStyle(raw: ITextBodyStyle | null, style: ITextBodyStyle | null): Record<string, any> | null {
    return ((raw?.wrapperStyle) || (style?.wrapperStyle)) ? {} : null;
}

function getBodyStyle(raw: ITextBodyStyle | null, style: ITextBodyStyle | null): Record<string, any> | null {
    return ((raw?.bodyStyle) || (style?.bodyStyle)) ? {} : null;
}

export function textBodyStyleMerge(raw: ITextBodyStyle | null, ...styles: ITextBodyStyle[]): ITextBodyStyle | null {
    return styles.reduce((prev, style) => merge(prev, style), raw);
}
